export default {
  mergeSavedColumns(
    savedColumns,
    defaultColumns,
    pinnedLastValue,
    pinnedFirstValue
  ) {
    let saved = null
    try {
      saved = savedColumns ? JSON.parse(savedColumns) : null
    } catch (_) {
      saved = null
    }

    const ordered =
      !Array.isArray(saved) || saved.length == 0
        ? defaultColumns.map((column) => ({ ...column }))
        : this.orderBySaved(saved, defaultColumns)

    if (pinnedLastValue) {
      const pinnedIndex = ordered.findIndex((x) => x.value === pinnedLastValue)
      if (pinnedIndex > -1) {
        const [pinned] = ordered.splice(pinnedIndex, 1)
        pinned.active = true
        ordered.push(pinned)
      }
    }

    if (pinnedFirstValue) {
      const pinnedIndex = ordered.findIndex((x) => x.value === pinnedFirstValue)
      if (pinnedIndex > -1) {
        const [pinned] = ordered.splice(pinnedIndex, 1)
        pinned.active = true
        ordered.unshift(pinned)
      }
    }

    return ordered
  },

  orderBySaved(saved, defaultColumns) {
    const savedByValue = new Map(
      saved
        .filter((column) => column && column.value)
        .map((column) => [column.value, column])
    )

    const ordered = []

    saved.forEach((column) => {
      if (!column || !column.value) return
      const schema = defaultColumns.find((x) => x.value === column.value)
      if (!schema) return
      ordered.push({ ...schema, active: column.active !== false })
    })

    defaultColumns.forEach((schema) => {
      if (savedByValue.has(schema.value)) return
      ordered.push({ ...schema })
    })

    return ordered
  },
}
